import { render, staticRenderFns } from "./labels.vue?vue&type=template&id=424b150d&scoped=true&"
import script from "./labels.vue?vue&type=script&lang=js&"
export * from "./labels.vue?vue&type=script&lang=js&"
import style0 from "./labels.vue?vue&type=style&index=0&id=424b150d&lang=scss&scoped=true&"
import style1 from "./labels.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b150d",
  null
  
)

export default component.exports